module.exports = __webpack_public_path__ + "static/img/zhengce.6f86656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/zhengce.png
// module id = 9QRa
// module chunks = 11